export default __webpack_public_path__ + "static/media/Screenshot 2021-03-03 111338.a1a51665.png";